module.exports = __webpack_public_path__ + "img/agents-circle.1395bd31.png";